<template>
    <div class="wtd-certificates">
        <img :src="`${staticBase}new-design/withdrawal-certificates/Binance.svg`" alt="" class="wtd-certificates__item">
        <img :src="`${staticBase}new-design/withdrawal-certificates/BtcTurk.svg`" alt="" class="wtd-certificates__item">
        <img :src="`${staticBase}new-design/withdrawal-certificates/Cointr.svg`" alt="" class="wtd-certificates__item">
        <img :src="`${staticBase}new-design/withdrawal-certificates/BlackRock.svg`" alt="" class="wtd-certificates__item">
        <img :src="`${staticBase}new-design/withdrawal-certificates/Cryptocom.svg`" alt="" class="wtd-certificates__item">
    </div>
</template>
<script>
import {mapGetters} from "vuex"

export default {
    name: "WithdrawalCertificates",
    computed:{
        ...mapGetters(['staticBase'])
    }
}
</script>
<style scoped>
.wtd-certificates {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: center;
}

@media (max-width: 1000px) {
    .wtd-certificates {
        margin-top: 10px;
        gap: 12px;
    }
}
</style>